// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"FooterButtonGroup_buttonWrapper__3CJij","buttonSubmit":"FooterButtonGroup_buttonSubmit__-nyi8","buttonReset":"FooterButtonGroup_buttonReset__3wdCQ"};